import { EntityMetadataMap, EntityDataModuleConfig } from '@ngrx/data';

const entityMetadata: EntityMetadataMap = {
    Shipment: {},
    Pickup: {},
    AddressBook: {},
    Contact: {},
    Invoice: {},
    Batch: {},
    CreditCard: {},
    Package: {},
    Commodity: {}
};

const pluralNames = {  };

export const entityConfig: EntityDataModuleConfig = {
    entityMetadata,
    pluralNames
};
